import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import type { AdItem } from '@sbt-web/network/types';
import Skyscraper from '../../Skyscraper';
import type { SectionProps } from './section';
type Props = SectionProps & {
  item: AdItem;
  newCreditAgricoleToggle?: boolean;
};
const SkyscraperSection: FC<Props> = t0 => {
  const $ = _c(10);
  const {
    item,
    classes: t1,
    newCreditAgricoleToggle
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  let t3;
  if ($[2] !== classes) {
    t3 = classnames(...classes);
    $[2] = classes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== item || $[5] !== newCreditAgricoleToggle) {
    t4 = <Skyscraper item={item} newCreditAgricoleToggle={newCreditAgricoleToggle} />;
    $[4] = item;
    $[5] = newCreditAgricoleToggle;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <aside className={t3}>{t4}</aside>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default SkyscraperSection;